import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledDownCaretIconWrapper } from './Select.styles';
import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const DownCaret = ({
  hasSelectedValues,
  clearable
}) => {
  const iconSize = useIconSize('100');
  if (clearable) {
    if (!hasSelectedValues) {
      return /*#__PURE__*/_jsx(StyledDownCaretIconWrapper, {
        $size: iconSize,
        children: /*#__PURE__*/_jsx(DownCaratIcon, {})
      });
    }
    return null;
  }
  return /*#__PURE__*/_jsx(StyledDownCaretIconWrapper, {
    $size: iconSize,
    children: /*#__PURE__*/_jsx(DownCaratIcon, {})
  });
};